export enum FeeTabs {
    Fiat = 'fiat',
    Trade = 'trade',
    Crypto = 'crypto',
}
